import { post } from '@/util/http'
/** 查询账户 */
export const getUsers = params => post(`/org/userManage/selectPage`, params);
// 新增账户信息
export const saveUser = params => post(`/org/userManage/insert`, params);
// 更新账户信息
export const updateUser = params => post(`/org/userManage/update`, params);
// 删除账户信息
export const deleteUser = params => post(`/org/userManage/delete`, params);

export const changePassword = params => post(`/org/userManage/changePassword`, params);
